import React, { useState, useEffect } from 'react'
import './ProductoExpositor.scss'
import { EquisIcons } from '../utils/icons'
import { DobleGuion } from './DobleGuion'
import { ProductoDetalleDescripcion } from '../components/ProductoDetalleDescripcion'
import ProductoDetalleCantidad from '../components/ProductoDetalleCantidad'
import ProductoDetalleTotal from '../components/ProductoDetalleTotal'
import ProductoDetalleBtnCompra from '../components/ProductoDetalleBtnCompra'
import Separator from '../components/Separator';
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom';
import { firstCharCapitalize } from '../utils/utils'
import { privilegeUser } from '../hooks/user'
import ContentExpositor from './ContentExpositor'
import { setFormatSelected } from '../actions/index'
import {OptionsProductDesactivate} from './OptionsProductDesactivate'
import { getProducts } from '../hooks/gets'
import _ from 'lodash';

const findProductsExpositorById = (product, allProduct) => {
    const productExpositors = JSON.parse(product.ProductosExpositor);
    let productsInExpositor = []
    for (let i = 0; i < productExpositors.length; i++) {
        const product = productExpositors[i];
        const productData = _.filter(allProduct, productList => {
            return productList.RefSuelto.trim() === product.RefSuelto.trim()
        })
        const productQuantity = { product: productData[0], quantity: product.Quantity }
        productsInExpositor.push(productQuantity)
    }
    return productsInExpositor;
}

const ProductoExpositor = (props) => {
    const { product, clickClose } = props
    const [productsExpositor, setProductsExpositor] = useState([])
    const [privilege, setPrivilege] = useState(undefined)

    useEffect(() => {
        getProducts().then(res => {
            props.setFormatSelected('expositor')
            const productsExpositor = findProductsExpositorById(product, res)
            setProductsExpositor(productsExpositor)
            getPrivilege()
        }).catch(err => {
            console.log('err', err)
        })
    }, [])

    const getPrivilege = async () => {
        setPrivilege(await privilegeUser())
    }

    return (
        <div className="producto-expositor-container">
            <div className="content">
                <div className="header">
                    <div className="title">
                        <div className="text">
                            <p>EXPOSITOR</p>
                            <DobleGuion />
                        </div>
                        <div className="botones">
                            <button className="pointer" onClick={clickClose}><EquisIcons size={15} /></button>
                        </div>
                    </div>
                </div>
                <div className="product">
                    <div className="title">
                        <p>{firstCharCapitalize(product.Nombre)}</p>
                    </div>
                    <div className="img">
                        <img src={"/static/imgProducts/" + product.Fotografia + "_p.jpg"} onError={(e) => {
                            e.target.onerror = null
                            e.target.src = '/static/img/no-imagen-fansa.png'
                        }} alt="" />
                    </div>
                    <div className="details-uno">
                        <div className="separator"><Separator /></div>
                        <div><ProductoDetalleDescripcion producto={product}></ProductoDetalleDescripcion></div>
                        <div className="separator"><Separator /></div>
                    </div>
                    <div className="details-dos">
                        <div className="separator"><Separator /></div>
                        {productsExpositor.length > 0 &&
                            <div><ContentExpositor productsExpositor={productsExpositor}></ContentExpositor></div>
                        }
                        <div className="separator"><Separator /></div>
                    </div>
                    <div className="options">
                        {!_.isEmpty(props.userActive) ?
                            <React.Fragment>
                                <div><ProductoDetalleCantidad producto={product} /></div>
                                <div className="separator"><Separator /></div>
                                <div className="total"><ProductoDetalleTotal producto={product}></ProductoDetalleTotal></div>
                                <div className="separator"><Separator /></div>
                                <div className="boton-compra"><ProductoDetalleBtnCompra product={product}></ProductoDetalleBtnCompra></div>
                                <div className="precio">
                                    {privilege &&
                                        <p>Precio de venta recomendado <strong>{product.PrecioTarifa}€</strong></p>
                                    }
                                </div>

                            </React.Fragment>
                            :
                            <OptionsProductDesactivate></OptionsProductDesactivate>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    setFormatSelected
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(ProductoExpositor)